/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DeviceIntegrationScheduleState,
  DeviceIntegrationScheduleState$inboundSchema,
} from "./deviceintegrationschedulestate.js";

/**
 * Sync schedules for one provider integration. Empty when no config is set for the provider.
 */
export type ListDeviceIntegrationSchedulesResult = {
  /**
   * Organization the schedules belong to.
   */
  organizationId: string;
  /**
   * Provider identifier.
   */
  provider: string;
  /**
   * State for each of the provider's sync schedules.
   */
  schedules: Array<DeviceIntegrationScheduleState>;
};

/** @internal */
export const ListDeviceIntegrationSchedulesResult$inboundSchema: z.ZodMiniType<
  ListDeviceIntegrationSchedulesResult,
  unknown
> = z.pipe(
  z.object({
    organization_id: z.string(),
    provider: z.string(),
    schedules: z.array(DeviceIntegrationScheduleState$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "organization_id": "organizationId",
    });
  }),
);

export function listDeviceIntegrationSchedulesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDeviceIntegrationSchedulesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListDeviceIntegrationSchedulesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDeviceIntegrationSchedulesResult' from JSON`,
  );
}
